const prefix = 'data';

export const SELECTORS = {
  quoteNumber: `[${prefix}="quote-number"]`,
  zipCode: `[${prefix}="zip-code"]`,
  formError: `[${prefix}="form-error"]`,
  formLoader: `[${prefix}="form-loader"]`,
  chaseFornWrapper: `[${prefix}="chase-form-wrapper"]`,
  chaseForm: `[${prefix}="chaseform"]`,
  quoteForm: `[${prefix}="quote-form"]`,
  policyForm: `[${prefix}="policy-form"]`,
  redirectButton: `[${prefix}="redirect-button"]`,
  submitButton: `[${prefix}="submit-button"]`,
  errorClass: 'is-red',
  submitClass: 'is-waiting',
};

export const SSO_TOKEN_API_URL = 'https://rest.us.synatic.com/lwccfscuat/webflow-api/getssotoken';

export const PAYMENT_US_KEYS = {
  token: 'token',
  id: 'itok',
};

export const SSO_API_PARAMS = {
  policyNumberName: 'av_plcy_no',
  mailZipName: 'av_pin',
};
